import React from 'react'
import { useParams } from 'react-router-dom'

import OffersConfigurator from '../components/OffersConfigurator'

import { getPackagesByAccountNumber, getPackages } from '~/customer/helpers'
import useCustomer from '~/customer/useCustomer'

interface ParamsProps {
  accountNumber?: string
}

const OffersConfiguratorContainer: React.FC = () => {
  const { customer } = useCustomer()
  const { accountNumber }: ParamsProps = useParams()

  let packages

  if (customer) {
    packages = accountNumber
      ? getPackagesByAccountNumber(customer, accountNumber)
      : getPackages(customer)
  }

  return customer ? (
    <OffersConfigurator customer={customer} packages={packages} accountNumber={accountNumber} />
  ) : null
}

export default OffersConfiguratorContainer
